import { match } from 'react-router'
import { useIntl, defineMessages } from 'react-intl'
import { AppLayout } from '../../../App/Layout/AppLayout'
import { Box, Flex, Text, Heading, LinkButton, Card, CardBody, Icon } from '@homebotapp/hb-react-component-catalog'
import { EstimatedMonthlyPaymentBreakdownCustomerDM } from '../../../Components/homeSearch/ListingDetails/EstimatedMonthlyPayment/EstimatedMonthlyPaymentBreakdown/EstimatedMonthlyPaymentBreakdownCustomerDM/EstimatedMonthlyPaymentBreakdownCustomerDM'

export const MSG = defineMessages({
  backToCalculators: {
    id: 'AffordabilityCalculator.backToCalculators',
    defaultMessage: 'Back to Calculators'
  },
  affordabilityUnderConstruction: {
    id: 'AffordabilityCalculator.affordabilityUnderConstruction',
    defaultMessage: 'Affordability Calculator Under Construction'
  },
  affordabilityUnderConstructionDescription: {
    id: 'AffordabilityCalculator.affordabilityUnderConstructionDescription',
    defaultMessage: 'This calculator is currently under construction. Please check back soon!'
  }
})

export interface AffordabilityCalculatorProps {
  match: match<{ buyerId?: string }>
}

export const AffordabilityCalculator = ({ match }: AffordabilityCalculatorProps) => {
  const intl = useIntl()

  return (
    <AppLayout loading={false} enableAgentDropdown match={match}>
      <Box mb={24}>
        <Box px={[5, null, 20]} py={[5, null, 10]}>
          <Flex mx='auto' maxWidth='1400px' direction='column' gap={4}>
            <Flex>
              <LinkButton
                mb={4}
                flex='0 0 auto'
                size={['sm', null, null, 'md']}
                onClick={() => history.back()}
                tracking={{
                  guid: '4v8BbfMrGmVowewNnMhM34',
                  descriptor: 'Back to Calculators',
                  ui_context: 'Affordability Calculator Page'
                }}
              >
                {intl.formatMessage(MSG.backToCalculators)}
              </LinkButton>
            </Flex>
            <Card>
              <CardBody margin='auto' textAlign='center'>
                <Icon mb={4} h={16} w={16} name='bot-head-construction' />
                <Heading mb={2} as='h1' size={['md', null, null, 'lg']} textAlign='left' fontWeight={800}>
                  {intl.formatMessage(MSG.affordabilityUnderConstruction)}
                </Heading>
                <Text size={['sm', null, null, 'md']}>
                  {intl.formatMessage(MSG.affordabilityUnderConstructionDescription)}
                </Text>
              </CardBody>
            </Card>
          </Flex>
        </Box>
        <EstimatedMonthlyPaymentBreakdownCustomerDM buyerId={match.params.buyerId} />
      </Box>
    </AppLayout>
  )
}
